import { getSelectedQueryModal } from "redux/SingleDataset/selectors";
import { setSelectedQueryModal } from "redux/SingleDataset/actions";
import { RefObject, useEffect, useRef, useState } from "react";
import Button from "views/components/QueryPanel/Button";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import FilterMenu from "views/components/FilterMenu";
import AddIcon from "assets/icons/AddIcon";
import { FilterMenuItemType, Position } from "types";
import styles from "./style.module.scss";

export interface AddFilterProps {
  rowRef: RefObject<HTMLDivElement>;
}

export default function AddFilter({ rowRef }: AddFilterProps) {
  const [btnPosition, setBtnPosition] = useState<Position | null>(null);
  const [showMenu, setShowMenu] = useState(false);

  const selectedModal = useSelector(getSelectedQueryModal);

  const btnRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const { datasetId } = useParams();
  const dispatch = useDispatch();

  const toggle = () => setShowMenu(!showMenu);

  const handleFilterSelection = (type: FilterMenuItemType) => {
    let position = btnPosition;
    dispatch(
      setSelectedQueryModal({
        type,
        position: position || undefined,
      }),
    );
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !menuRef.current?.contains(event.target as Node) &&
        !btnRef.current?.contains(event.target as Node)
      ) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      const row = rowRef.current;
      const isRightAligned = row
        ? rect.left - row.getBoundingClientRect().left >
          row.getBoundingClientRect().width * 0.6
        : false;

      const top = rect.bottom + window.scrollY + 4;
      const left =
        rect.left + (isRightAligned ? rect.width : 0) + window.scrollX;

      if (menuRef.current) {
        menuRef.current.style.setProperty(
          "--menu-transform",
          isRightAligned ? "translate(-100%)" : "none",
        );
        menuRef.current.style.setProperty("--menu-top", `${top}px`);
        menuRef.current.style.setProperty("--menu-left", `${left}px`);

        setBtnPosition({ top, left });
      }
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu, selectedModal, rowRef]);

  return (
    <div
      className={styles.addFilterBtn}
      data-testid="add-filter-btn"
      ref={btnRef}
      onClick={toggle}
    >
      {
        <Button
          icon={<AddIcon />}
          title="Add Filter"
          onClick={toggle}
          dataTestId="add-filter-button"
        />
      }
      {showMenu && (
        <div
          className={styles.menuPositioner}
          data-testid="menu-positioner"
          ref={menuRef}
        >
          <FilterMenu onSelect={handleFilterSelection} datasetId={datasetId!} />
        </div>
      )}
    </div>
  );
}
